import React from 'react';

import * as _ from 'lodash';

const tableConfig = [
  { name: 'グループ名', className: '' },
  { name: '', className: 'action' },
];

const LwGroupTable = ({ lineGroups, onUpdate, toggleDialogDelete }) => {
  return (
    <div className='LineGroupTable'>
      <table className='table table--line-group'>
        <thead className='table__header'>
          <tr className='table__label'>
            {_.map(tableConfig, item => (
              <td
                className={`value-table value-table--table__label ${
                  item.className
                }`}
                key={item.name}
              >
                <span className='value-table__label'>{item.name}</span>
              </td>
            ))}
          </tr>
        </thead>
        <tbody>
          {_.map(lineGroups, lwGroup => (
            <tr className='table__item' key={lwGroup.id}>
              <td className='value-table'>{lwGroup.name}</td>
              <td className='value-table value-table__action'>
                <div className='value-table__normal'>
                  <button
                    className='btn--sm--stay'
                    onClick={() => onUpdate(lwGroup.id, lwGroup.name)}
                  >
                    編集
                  </button>
                  <button
                    className='btn--sm--negative'
                    onClick={() => toggleDialogDelete(lwGroup.id)}
                  >
                    削除
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LwGroupTable;



// WEBPACK FOOTER //
// ./src/components/tables/LwGroupTable.jsx